import { Modal, Select } from 'antd';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import Enums from 'utils/EnumsManager';
import { resetOnDrop, setActions } from '../../flow/actions';

const { Option } = Select;
const { REPORTS, DROPZONES, FieldTypes } = Enums;
const { DateOnly, DateTime } = FieldTypes;
const { GROUPS } = DROPZONES;
const { GROUPS_ZONE_TAG_ACTIONS } = REPORTS;

const defaultProps = {};
const propTypes = {
  setActions: PropTypes.func.isRequired,
  resetOnDrop: PropTypes.func.isRequired
};

class GroupModal extends Component {
  state = {
    value: GROUPS_ZONE_TAG_ACTIONS[0]
  };

  handleOptionChange = value => this.setState({ value });
  handleCancelClick = () => this.props.resetOnDrop();
  handleOkClick = () => {
    const columns = this.props.data.filter(col => col.onDrop);
    if (columns.length === 1) {
      this.props.setActions(columns[0].id, this.state.value);
      this.props.resetOnDrop();
    } else {
      // Report error
      console.error('Invalid data!');
    }
  };

  render() {
    const i18n = 'page.ReportTableSetup';
    const options = GROUPS_ZONE_TAG_ACTIONS.map(action => (
      <Option key={action} value={action}>
        <FormattedMessage id={`${i18n}.actions.${action}`} />
      </Option>
    ));
    const showModal = this.props.data.some(
      record =>
        record.belongTo === GROUPS &&
        record.onDrop &&
        (record.type === DateOnly || record.type === DateTime)
    );

    return (
      <Modal
        visible={showModal}
        title={<FormattedMessage id={`${i18n}.modals.aggregates`} />}
        onOk={this.handleOkClick}
        onCancel={this.handleCancelClick}
        destroyOnClose
      >
        <Select
          className="full-width"
          onChange={this.handleOptionChange}
          size="small"
          defaultValue={GROUPS_ZONE_TAG_ACTIONS[0]}
        >
          {options}
        </Select>
      </Modal>
    );
  }
}

const mapStateToProps = ({ reportSetup }) => ({
  data: reportSetup.sider.availableColumns
});
const mapDispatchToProps = {
  setActions,
  resetOnDrop
};
GroupModal.defaultProps = defaultProps;
GroupModal.propTypes = propTypes;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupModal);



// WEBPACK FOOTER //
// ./src/views/ReportTableSetup/components/GroupsZone/Modal.jsx